import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { LoadingIndicator } from 'common/components/preloader';
import { v4 } from 'node-uuid';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import { trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME } from 'common/tracking';

export default class AllGuides extends Component {
  constructor(props) {
    super(props);
    this.renderGuide = this.renderGuide.bind(this);
  }

  componentDidMount() {
    this.props.fetchAllGuidesIfNeeded();
    trackMixpanel("Viewed help content", {
      "contentType": "guide",
      "pageType": "main index",
      "categorySlug": null,
      "slug": null,
    })
  }

  renderGuide({ slug, title }) {
    return (
      <Link to={`/help/guides/${slug}/`} key={v4()} className="column category guide">
        <div className="tile">
          <i className="fa fa-book" />
          <h4>{ title }</h4>
        </div>
      </Link>);
  }

  render() {
    const { data, isLoading } = this.props;

    if (!data || isLoading) {
      return <LoadingIndicator />;
    }

    const clientGuides = data.filter(({ user_type }) => (user_type === 'client'));
    const creativeGuides = data.filter(({ user_type }) => (user_type === 'creative'));

    return (
      <div className="all-guides-content">
        <Meta
          title="Guides | Help | crowdspring"
          meta={[
            { name: 'description', content: "Design and writing guides" },
            { name: "keywords", content: "crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing" }
          ]}
          link={[{ rel: "canonical", href: getCanonicalURL(`/help/guides/`) }]}
        />
        <section className="block">
          <div className="row columns">
            <h2>Clients</h2>
          </div>
          <div className="row small-up-1 medium-up-2 large-up-4">
            { clientGuides.map(this.renderGuide) }
          </div>
        </section>
        <section className="block">
          <div className="row columns">
            <h2>Creatives</h2>
          </div>
          <div className="row small-up-1 medium-up-2 large-up-4">
            { creativeGuides.map(this.renderGuide) }
          </div>
        </section>
      </div>);
  }
}

AllGuides.propTypes = {
  fetchAllGuidesIfNeeded: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  data: PropTypes.array,
};



// WEBPACK FOOTER //
// ./help/components/all_guides.jsx